const style = {
  row: {
    border: `1px solid transparent`,
    borderBottom: `1px solid #666`,
    ':hover': {
      border: `1px solid #666`,
      background: `#fbfbfb`
    }
  },
  rowActive: {
    border: `1px solid #666`,
    background: `#fbfbfb`
  },
  permRow: {
    borderColor: `#666`
  },
  permRowActive: {
    borderTop: `1px solid #666`
  },
  header: {
    borderBottom: `1px solid #666`
  },
  expand: {
    fontSize: `12px`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/User/partials/GroupTable/style/ColorBlind/list.js